const divModalCloneCheck = {
  text1: 'La Checklist',
  text2: 'se clonará para el Tipo de Servicio y la Periodicidad seleccionados.',
};

export default divModalCloneCheck;
